import axios from "axios"
import type {
  IDonateRequest,
  IDonateResponse,
  IGetPaymentMethodsRequest,
  IGetPaymentMethodsResponse,
} from "./donate.model"

export const donateForm = async (url: string, data: IDonateRequest): Promise<IDonateResponse> => {
  const payload: IDonateRequest = data
  const response = await axios.post<IDonateResponse>(url, payload)

  return response.data
}

export const getPaymentMethods = async (
  url: string,
  data: IGetPaymentMethodsRequest,
): Promise<IGetPaymentMethodsResponse> => {
  const payload: IGetPaymentMethodsRequest = data
  const response = await axios.get<IGetPaymentMethodsResponse>(url, { params: payload })

  return response.data
}
